module.exports = __webpack_public_path__ + "media/images/konintodoke/diagnosis/kirameki_stage-62ea04fd9a72ed4ba32542207eb98ffb.png";